/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from '../../main.js'

import axios from "@/axios.js"
import store from "@/store/store.js"
const {
  endpoint,
  activationFee
} = require('@/../config.js');

export default {
  addProduct({
    commit
  }, product) {
    return new Promise((resolve, reject) => {
      var timestamp = Date.now();
      vm.$pouch
        .post({
            product_code: product.product_code,
            product_name: product.product_name,
            cost_price: product.cost_price,
            retail_price: product.retail_price,
            low_stock: product.low_stock,
            stock: product.stock,
            type: "product",
            date_created: timestamp,
            date_updated: timestamp,
          }, {},
          "express"
        )
        .then((res) => {
          if (res.ok) {
            // commit('ADD_PRODUCT', Object.assign(i, {
            //   id: res._id
            // }))
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => reject(err));
    })
  },
  updateProduct({
    commit
  }, product) {
    return new Promise((resolve, reject) => {
      vm.$pouch
        .put({
            _id: product._id,
            _rev: product._rev,
            product_code: product.product_code,
            product_name: product.product_name,
            cost_price: product.cost_price,
            retail_price: product.retail_price,
            low_stock: product.low_stock,
            stock: product.stock,
            type: "product",
            date_updated: Date.now(),
          }, {},
          "express"
        )
        .then((res) => {
          if (res.ok) {
            // commit('UPDATE_PRODUCT', res)
            resolve(res);
          } else {
            reject(res);
          }
        })
        .catch((err) => reject(err));
    })
  },
  /* *********** OLD API ************* */
  fetchProducts({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint + "/products/")
        .then((response) => {
          commit('SET_PRODUCTS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // updateProduct({
  //   commit
  // }, method) {
  //   return new Promise((resolve, reject) => {
  //     axios.patch(endpoint + `/products/${method.id}/`, method)
  //       .then((response) => {
  //         commit('UPDATE_PRODUCT', response.data)
  //         resolve(response)
  //       })
  //       .catch((error) => {
  //         reject(error)
  //       })
  //   })
  // },
  removeProduct({
    commit
  }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(endpoint + `/products/${itemId}/`)
        .then((response) => {
          commit('REMOVE_PRODUCT', itemId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },


  // categories
  addCategory({
    commit
  }, method) {
    return new Promise((resolve, reject) => {
      axios.post(endpoint + "/categories/", method)
        .then((response) => {
          commit('ADD_CATEGORY', Object.assign(response.data, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCategories({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get(endpoint + "/categories/")
        .then((response) => {
          commit('SET_CATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateCategory({
    commit
  }, method) {
    return new Promise((resolve, reject) => {
      axios.patch(endpoint + `/categories/${method.id}/`, method)
        .then((response) => {
          commit('UPDATE_CATEGORY', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeCategory({
    commit
  }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(endpoint + `/categories/${itemId}/`)
        .then((response) => {
          commit('REMOVE_CATEGORY', itemId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

}